import React, { useState } from 'react';

function Admin() {
  // Stany do obsługi logowania
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const sheetEditUrl = "https://docs.google.com/spreadsheets/d/1AZEz6lWVjpp4KgWeX2TMig0HvYADVN7KeT3FvljOk0w/edit?gid=425037062#gid=425037062";

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Pobieranie zmiennych (obsługa zarówno Vite, jak i Create React App)
    const envUser = (import.meta.env && import.meta.env.VITE_ADMIN_USERNAME) || process.env.REACT_APP_ADMIN_USER;
    const envPass = (import.meta.env && import.meta.env.VITE_ADMIN_PASSWORD) || process.env.REACT_APP_ADMIN_PASS;

    // Sprawdzenie poprawności
    if (username === envUser && password === envPass) {
      setIsLoggedIn(true);
      setError('');
    } else {
      setError('Nieprawidłowy login lub hasło.');
    }
  };

  // 1. WIDOK LOGOWANIA (jeśli nie jest zalogowany)
  if (!isLoggedIn) {
    return (
      <div style={{ padding: '50px', textAlign: 'center', fontFamily: 'sans-serif', backgroundColor: '#f5f0e1', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h2>Zaloguj się do panelu</h2>
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%', maxWidth: '300px' }}>
          <input 
            type="text" 
            placeholder="Login" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '16px' }}
          />
          <input 
            type="password" 
            placeholder="Hasło" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '16px' }}
          />
          {error && <p style={{ color: '#d9534f', margin: 0, fontWeight: 'bold' }}>{error}</p>}
          <button 
            type="submit" 
            style={{ padding: '12px', backgroundColor: '#5a9a8a', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}
          >
            Zaloguj
          </button>
        </form>
      </div>
    );
  }

  // 2. WIDOK PANELU (jeśli jest zalogowany)
  return (
    <div style={{ padding: '50px', textAlign: 'center', fontFamily: 'sans-serif', backgroundColor: '#f5f0e1', minHeight: '100vh' }}>
      <h1>Panel Zarządzania Treścią (CMS)</h1>
      <p style={{ fontSize: '18px', maxWidth: '600px', margin: '20px auto' }}>
        Witaj! Aby zmienić teksty na stronie, kliknij w poniższy przycisk i edytuj odpowiednie pola w Arkuszu Google. 
        Zmiany pojawią się na stronie po kilku minutach (Google potrzebuje chwili na odświeżenie publikacji).
      </p>
      <a 
        href={sheetEditUrl} 
        target="_blank" 
        rel="noreferrer"
        style={{ display: 'inline-block', padding: '20px 40px', backgroundColor: '#5a9a8a', color: 'white', textDecoration: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '20px' }}
      >
        👉 OTWÓRZ ARKUSZ Z TEKSTAMI
      </a>
      <div style={{ marginTop: '50px', color: '#666' }}>
        <p><strong>Pamiętaj:</strong> Nie zmieniaj nazw w pierwszej kolumnie (Klucze). Edytuj tylko prawą kolumnę z tekstami.</p>
      </div>
    </div>
  );
}

export default Admin;